<div>
  <div style="text-align: center; padding-top: 1rem;">
    <h3>Invitation</h3>
  </div>


  <div style="min-height: 250px; min-width: 250px;" *ngIf="object">
    <div>

      {{object.id}}
    </div>
    <div class="flex">
      <div class="spacer font-bold">
        {{formatLongDate(session.lang, object.startTime)}}
      </div>
    </div>
    <div class="mb-2">
      {{formatDisplayTime(this.session.lang,object.startTime)}}-
      {{formatDisplayTime(this.session.lang,object.endTime)}}
      ({{formatMins(object.durationMins,_common)}})
    </div>
    <ng-container *ngIf="object.space; let o">
      <app-space-card [space]="$any(object.space)" class="space_card_noBorder"></app-space-card>
    </ng-container>
    <div (click)="accept()">
      Accept
    </div>
  </div>
</div>